export function checkIfKaiserHealthPlan(healthPlan?: string | null) {
  return healthPlan && healthPlan === 'kaiser_permanente_northern_california'
}

export function checkIfKaiserSource(source?: string | null) {
  return source && source === 'Kaiser Permanente, Northern California'
}

export function checkIfSelfPaySource(source?: string | null) {
  return source === 'SELFPAY'
}
